import { createContext, useCallback, useContext, useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import toast from "react-hot-toast";

// Create a context
export const RecaptchaContext = createContext();

export const RecaptchaProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleRecaptcha = useCallback(
    async submitFunc => {
      setLoading(true);
      if (!executeRecaptcha) {
        toast.error("Execute recaptcha not yet available");
        return;
      }
      const gReCaptchaToken = await executeRecaptcha();
      // console.log(gReCaptchaToken, "response Google reCaptcha server");
      let response;
      try {
        response = await submitEnquiryForm(gReCaptchaToken, submitFunc);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
      return response;
    },
    [executeRecaptcha],
  );

  const submitEnquiryForm = async (gReCaptchaToken, func) => {
    return await fetch("/api/recaptcha", {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        gRecaptchaToken: gReCaptchaToken,
      }),
    }).then(res => res.json());
  };

  return (
    <RecaptchaContext.Provider value={{ loading, handleRecaptcha }}>
      {children}
    </RecaptchaContext.Provider>
  );
};
